/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Resource_SkillInputs */

const en_directory_agents_resource_skill = /** @type {(inputs: Directory_Agents_Resource_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent entry point: safety rules and the five-step procedure in SKILL.md format.`)
};

const zh_directory_agents_resource_skill = /** @type {(inputs: Directory_Agents_Resource_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 入口：SKILL.md 格式的安全规则与五步流程。`)
};

/**
* | output |
* | --- |
* | "The agent entry point: safety rules and the five-step procedure in SKILL.md format." |
*
* @param {Directory_Agents_Resource_SkillInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_resource_skill = /** @type {((inputs?: Directory_Agents_Resource_SkillInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Resource_SkillInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_resource_skill(inputs)
	return zh_directory_agents_resource_skill(inputs)
});
export { directory_agents_resource_skill as "directory.agents.resource_skill" }